module.exports = __webpack_public_path__ + "img/SoenkeSchwenk_140x140_rund.71aa9563.jpg";